var _path, _rect, _polygon, _path2, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcons8OutlookCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "24px",
    height: "24px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1976d2",
    d: "M28,13h14.533C43.343,13,44,13.657,44,14.467v19.066C44,34.343,43.343,35,42.533,35H28V13z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 15.542,
    x: 28,
    y: 17.958,
    fill: "#fff"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fill: "#1976d2",
    points: "27,44 4,39.5 4,8.5 27,4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M15.25,16.5c-3.176,0-5.75,3.358-5.75,7.5s2.574,7.5,5.75,7.5S21,28.142,21,24 S18.426,16.5,15.25,16.5z M15,28.5c-1.657,0-3-2.015-3-4.5s1.343-4.5,3-4.5s3,2.015,3,4.5S16.657,28.5,15,28.5z"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 2.7,
    height: 2.9,
    x: 28.047,
    y: 29.737,
    fill: "#1976d2"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 2.7,
    height: 2.9,
    x: 31.448,
    y: 29.737,
    fill: "#1976d2"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 2.7,
    height: 2.9,
    x: 34.849,
    y: 29.737,
    fill: "#1976d2"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 2.7,
    height: 2.9,
    x: 28.047,
    y: 26.159,
    fill: "#1976d2"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 2.7,
    height: 2.9,
    x: 31.448,
    y: 26.159,
    fill: "#1976d2"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    width: 2.7,
    height: 2.9,
    x: 34.849,
    y: 26.159,
    fill: "#1976d2"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    width: 2.7,
    height: 2.9,
    x: 38.25,
    y: 26.159,
    fill: "#1976d2"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    width: 2.7,
    height: 2.9,
    x: 28.047,
    y: 22.706,
    fill: "#1976d2"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    width: 2.7,
    height: 2.9,
    x: 31.448,
    y: 22.706,
    fill: "#1976d2"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    width: 2.7,
    height: 2.9,
    x: 34.849,
    y: 22.706,
    fill: "#1976d2"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    width: 2.7,
    height: 2.9,
    x: 38.25,
    y: 22.706,
    fill: "#1976d2"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    width: 2.7,
    height: 2.9,
    x: 31.448,
    y: 19.112,
    fill: "#1976d2"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    width: 2.7,
    height: 2.9,
    x: 34.849,
    y: 19.112,
    fill: "#1976d2"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    width: 2.7,
    height: 2.9,
    x: 38.25,
    y: 19.112,
    fill: "#1976d2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8OutlookCalendar);
export default __webpack_public_path__ + "static/media/icons8-outlook-calendar.c4bb644f4c75360a642b9e445289ffcc.svg";
export { ForwardRef as ReactComponent };